{
  "version": 1,
  "asset_id": "4a3673d8-9349-4f86-86d0-245e14e3d60d",
  "project_id": "b3b85082-7610-442f-94fe-f2e293553923",
  "url": "/__l5e/assets-v1/4a3673d8-9349-4f86-86d0-245e14e3d60d/chavel-logo-236.webp",
  "r2_key": "a/v1/b3b85082-7610-442f-94fe-f2e293553923/4a3673d8-9349-4f86-86d0-245e14e3d60d/chavel-logo-236.webp",
  "original_filename": "chavel-logo-236.webp",
  "size": 8040,
  "content_type": "image/webp",
  "created_at": "2026-08-26T03:51:27Z"
}
